import { PersonalityType } from "./PersonalityType"

export interface PersonalityTypeInfo {
    typeNumber: 1 | 2 | 3 | 4 | 5
    boy: PersonalityTypeData
    girl: PersonalityTypeData
}

export interface PersonalityTypeData {
    description: string
    kidMatch: string
    storyBlanks: Array<Array<string>>
}

export const personalityTypeInfoMap: Map<PersonalityType, PersonalityTypeInfo> =
    new Map([
        [
            PersonalityType.SHY,
            {
                typeNumber: 1,
                boy: {
                    description:
                        "You are comfortable being on your own, and like to hear what others have to say. You like to spend time with the same small " +
                        "group of good friends. You have plans for your life and think ahead.",
                    kidMatch: "Kevin",
                    storyBlanks: [
                        ["play video games", "read", "text his best friend"],
                        [
                            "has a few good friends ",
                            "likes to hear what friends have to say ",
                            "does projects with friends for school",
                        ],
                        [
                            "are gross ",
                            "look really bad ",
                            "are really disgusting",
                        ],
                        [
                            "it’s not something he’d ever want to do ",
                            "there’s so many other things he wants to do ",
                            "he wants to be healthy",
                        ],
                        [
                            "are really stupid ",
                            "smell gross ",
                            "are definitely not cool",
                        ],
                    ],
                },
                girl: {
                    description:
                        "You are kind of shy, and that’s great because it means you’re a good listener. You have a few good friends who are very " +
                        "close to your heart. You have plans for your life and think ahead.",
                    kidMatch: "Karli",
                    storyBlanks: [
                        [
                            "watch movies",
                            "talk on the phone",
                            "text her best friend",
                        ],
                        [
                            "has a few good friends",
                            "likes to hear what friends have to say",
                            "does projects with friends for school",
                        ],
                        [
                            "are gross",
                            "look really bad",
                            "are really disgusting",
                        ],
                        [
                            "it’s not something she’d ever want to do",
                            "there’s so many other things she wants to do",
                            "she wants to be healthy",
                        ],
                        [
                            "are really stupid",
                            "smell gross",
                            "are definitely not cool",
                        ],
                    ],
                },
            },
        ],
        [
            PersonalityType.RISK_TAKER,
            {
                typeNumber: 2,
                boy: {
                    description:
                        "You like to take risks, but you know where to draw the line. You like to do exciting things and have adventures with other kids." +
                        " You take opportunities as they come up, and never say No.",
                    kidMatch: "Trevor",
                    storyBlanks: [
                        [
                            "skateboard",
                            "hang out with friends",
                            "go on rides at the fair",
                        ],
                        [
                            "hangs out with a cool group of friends",
                            "has been friends with the same group forever",
                            "and his friends look out for one another",
                        ],
                        [
                            "are nasty",
                            "are definitely not fun or exciting",
                            "look really stupid",
                        ],
                        [
                            "it would be really dumb",
                            "smoking or vaping isn’t cool",
                            "it’s just gross",
                        ],
                        [
                            "are not cool",
                            "are weird",
                            "are not people to hang out with",
                        ],
                    ],
                },
                girl: {
                    description:
                        "You are not afraid to take risks, but you know where to draw the line. You love to have fun, and people like you because of this. " +
                        "You take opportunities as they come up, and never say No.",
                    kidMatch: "Tracy",
                    storyBlanks: [
                        [
                            "swim and dive",
                            "hang out with friends",
                            "go on rides at the fair",
                        ],
                        [
                            "hangs out with a cool group of friends",
                            "has been friends with the same group forever",
                            "and her friends look out for one another",
                        ],
                        [
                            "are nasty",
                            "are definitely not fun or exciting",
                            "look really stupid",
                        ],
                        [
                            "it would be really dumb",
                            "smoking or vaping isn’t cool",
                            "it’s just gross",
                        ],
                        [
                            "are not cool",
                            "are weird",
                            "are not people to hang out with",
                        ],
                    ],
                },
            },
        ],
        [
            PersonalityType.EXTROVERT,
            {
                typeNumber: 3,
                boy: {
                    description:
                        "You like to be around other kids most of the time. You have a large group of friends to do things with. Other people like you, " +
                        "and that feels good. You are a natural leader and you have lots of energy.",
                    kidMatch: "Andre",
                    storyBlanks: [
                        [
                            "hang out at the mall",
                            "meet new people",
                            "be in his school play",
                        ],
                        [
                            "has friends who are really great",
                            "and his friends have loads of fun together",
                            " gets to decide what the group will do",
                        ],
                        [
                            "are stupid things to do",
                            "wouldn’t be fun at all",
                            "are just gross",
                        ],
                        [
                            "he has way too much fun stuff to do",
                            "he’d be upset if his friends tried smoking or vaping",
                            "it’s not cool at all",
                        ],
                        ["look ugly", "are gross", "are sorry-looking"],
                    ],
                },
                girl: {
                    description:
                        "You have lots of friends. You feel happy when you are with a group of other kids. Your friends like being around you because " +
                        "you have lots of energy. You are often the one who decides what you and your friends are going to do.",
                    kidMatch: "Alexis",
                    storyBlanks: [
                        [
                            "hang out at the mall",
                            "meet new people",
                            "be in her school band",
                        ],
                        [
                            "has friends who are really great",
                            "and her friends have loads of fun together",
                            " gets to decide what the group will do",
                        ],
                        [
                            "are stupid things to do",
                            "wouldn’t be fun at all",
                            "are just gross",
                        ],
                        [
                            "she has way too much fun stuff to do",
                            "she’d be upset if her friends tried smoking or vaping",
                            "it’s not cool at all",
                        ],
                        ["look ugly", "are gross", "are sorry-looking"],
                    ],
                },
            },
        ],
        [
            PersonalityType.ATHLETIC,
            {
                typeNumber: 4,
                boy: {
                    description:
                        "You are at your best when doing something athletic. You like to be with other people who play sports, and they like " +
                        "to be with you. You get on well with all kinds of people. You are good at leading and at being a team player.",
                    kidMatch: "John",
                    storyBlanks: [
                        ["play hoops", "play baseball", "swim"],
                        [
                            "has a bunch of friends",
                            "and his friends do sports together",
                            "and his friends are happiest when they’re on the move",
                        ],
                        [
                            "are gross",
                            "look and smell bad",
                            "are definitely not cool",
                        ],
                        [
                            "it would slow him down",
                            "he’d be upset if her friends tried smoking or vaping",
                            "it would get in the way",
                        ],
                        [
                            "are setting a bad example",
                            "are gross",
                            "are definitely not cool",
                        ],
                    ],
                },
                girl: {
                    description:
                        "You feel best when you’re active. You and your friends like to meet up to play some kind of sport. You get " +
                        "on well with all sorts of" +
                        " people. You are good at leading and at being a team player.",
                    kidMatch: "Jessica",
                    storyBlanks: [
                        ["play soccer", "play basketball", "swim"],
                        [
                            "has a bunch of friends",
                            "and her friends do sports together",
                            "and her friends are happiest when they’re on the move",
                        ],
                        [
                            "are gross",
                            "look and smell bad",
                            "are definitely not cool",
                        ],
                        [
                            "it would slow her down",
                            "she’d be upset if her friends tried smoking or vaping",
                            "it would get in the way",
                        ],
                        [
                            "are setting a bad example",
                            "are gross",
                            "are definitely not cool",
                        ],
                    ],
                },
            },
        ],
        [
            PersonalityType.KIND_HELPFUL,
            {
                typeNumber: 5,
                boy: {
                    description:
                        "You are good at helping your friends, and they like to help you. People like you because you treat them with respect. You stay" +
                        " calm when the others panic. You feel responsible for people.",
                    kidMatch: "Michael",
                    storyBlanks: [
                        [
                            "hang out with his best friend",
                            "help his dad",
                            "babysit his little sister",
                        ],
                        [
                            "has a few really good friends",
                            "and his friends get along great",
                            "is the one who stays calm and smoothes things over",
                        ],
                        [
                            "are totally wrong",
                            "could get you into trouble",
                            "are not nice things to do",
                        ],
                        [
                            "it’s not a cool thing to do",
                            "he cares about his friends",
                            "he’d worry about getting sick",
                        ],
                        [
                            "are setting a bad example",
                            "aren’t cool",
                            " are doing something wrong",
                        ],
                    ],
                },
                girl: {
                    description:
                        "You are good at taking care of your friends, and they take care of you. People like you because of all " +
                        "the kind things you do for them when they need help. You calm your friends down when they get upset.",
                    kidMatch: "Michelle",
                    storyBlanks: [
                        [
                            "hang out with her best friend",
                            "cook with her mom",
                            "babysit her little brother",
                        ],
                        [
                            "has a few really good friends",
                            "and her friends get along great",
                            "is the one who stays calm and smoothes things over",
                        ],
                        [
                            "are totally wrong",
                            "could get you into trouble",
                            "are not nice things to do",
                        ],
                        [
                            "it’s not a cool thing to do",
                            "she cares about her friends",
                            "she’d worry about getting sick",
                        ],
                        [
                            "are setting a bad example",
                            "aren’t cool",
                            "are doing something wrong",
                        ],
                    ],
                },
            },
        ],
    ])
